
import DynamicFormPreview from "../components/features/DynamicPreview";
import FbPermission from "../components/features/FbPermission";
import FbStaticText from "../components/features/FbStaticText";
// import FbTimeline from "../components/features/FbTimeline";
import Formbuilder from "../main";
const FbRoutes = [
  {
    index: true,
    element: <Formbuilder />
  },
  {
    path: 'permission',
    element: <FbPermission />
  },
  {
    path: 'timeLine',
    element: <FbStaticText />
    // element: <FbTimeline />
  },
  // {
  //   path: 'staticText',
  //   element: <FbStaticText/>
  // },
  {
    path: 'preview',
    element: <DynamicFormPreview />
  },

];

export default FbRoutes;
